import { useAppContext } from "../../../AppProvider";

export const useListProps = () => {
  const { dictionary } = useAppContext();

  return {
    path: `/logistic-service/order-events`,
    banner: {
      enabled: false,
    },
    defaultPagination: {
      page: 0,
      size: 200,
    },
    sorting: [
      {
        orderBy: "desc",
        column: "eventDate",
        isDefault: true,
      },
    ],
    actionBar: { enabled: false },
    pagination: { enabled: false },
    title: <h3>{dictionary.notifications.event_list}</h3>,
    selectRowsEnabled: { enabled: false },
  };
};
